import dateToObject from "@utils/date/dateToObject";

/**
 * Date型からYYYY-MMに変換
 */
export const convertDateToYYYYHyphenMM = (date: Date = new Date()): string => {
  const { year, month } = dateToObject(date);
  return `${year}-${month.padStart(2, "0")}`;
};
